import type { FC } from "react";
import styled from "styled-components";
import { Header } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/table-top/Header";
import { ActionButtons } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/table-top/ActionButtons";
import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { SearchContainer } from "app/pages/workspace/StyledComponent";
import { SearchInput } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import type {
    IFilters } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/types";
import {
    EIndustriesType
} from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/types";
import { getExcelLink } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/table-top/getExcelLink";
import type { CategoryId } from "app/common/services/categoryService.types";
import { allTrackers } from "app/services/track/track";

interface ITableTop {
    filters: IFilters;
    setFilters: (filters: IFilters) => void;
    favorites: Array<CategoryId>;
    isFavoritesToggleDisabled: boolean;
    favoritesAmount: number;
}

const HeaderContainer = styled(BaseFlex)`
    padding: 24px 8px 24px 24px;
`;

export const TableTop: FC<ITableTop> = (props) => {
    const { filters, setFilters, favorites, isFavoritesToggleDisabled, favoritesAmount } = props;
    const { search, isFavorites, industriesType } = filters;
    const i18n = i18nFilter();
    const onSearchChange = (search) => {
        setFilters({ ...filters, search });
    };
    const onIsFavoriteToggle = () => {
        const updatedValue = !isFavorites;
        allTrackers.trackEvent(
            "Checkbox",
            "toggle",
            `${updatedValue ? "Starred only" : "Show all industries"}/${favoritesAmount}`,
        );
        setFilters({ ...filters, isFavorites: updatedValue });
    };
    const onIndustriesTypeToggle = (industriesType) => {
        const eventName = `industries toggle/${EIndustriesType[industriesType]}`;
        allTrackers.trackEvent("toggle", "click", eventName);
        setFilters({ ...filters, industriesType });
    };
    return (
        <>
            <HeaderContainer justifyContent={"space-between"}>
                <Header />
                <ActionButtons
                    onIsFavoriteToggle={onIsFavoriteToggle}
                    favoritesAmount={favoritesAmount}
                    excelLink={getExcelLink(filters, favorites)}
                    isFavoritesToggleDisabled={isFavoritesToggleDisabled}
                    industriesType={industriesType}
                    onIndustriesTypeToggle={onIndustriesTypeToggle}
                    filters={filters}
                />
            </HeaderContainer>
            <SearchContainer>
                <SearchInput
                    clearValue={false}
                    defaultValue={search}
                    onChange={onSearchChange}
                    placeholder={i18n("forms.search.placeholder")}
                />
            </SearchContainer>
        </>
    );
};
